/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ticket_received_explainer = () => `Ein Ticket kann einmal weitergegeben werden, dieses können Sie also nicht erneut teilen. Passt es nicht? Dann geben Sie es an die Person zurück, die es geteilt hat — sie kann es anschließend der richtigen Person geben.`
